module.exports = __webpack_public_path__ + "img/medium.cf7e857.svg";